// extracted by mini-css-extract-plugin
module.exports = {"root":"TextArea--root--3a5Pn"};